<template>
  <div class="main_content_wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ProductOrdersHome",
};
</script>
